/** @param {string} id */
export default function fixId(id) {
	if (!id) return id

	const [firstChar, ...rest] = id.replace(/^#/, '')

	if (!(firstChar in numbers)) return id

	const newId = `${numbers[firstChar]}${rest}`

	return id.startsWith('#') ? `#${newId}` : newId
}

const numbers = {
	0: 'zero',
	1: 'one',
	2: 'two',
	3: 'three',
	4: 'four',
	5: 'five',
	6: 'six',
	7: 'seven',
	8: 'eight',
	9: 'nine',
}
